import React, { useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';

export default function CredentialCopyDialog({ credentials, onClose }) {
  const [notice, setNotice] = useState('');
  useEffect(() => {
    setNotice('');
    if (!credentials) return undefined;
    const timeout = setTimeout(onClose, 5 * 60 * 1000);
    return () => clearTimeout(timeout);
  }, [credentials, onClose]);
  const copy = async (value, label) => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('unavailable');
      await navigator.clipboard.writeText(value);
      setNotice(`${label} copied. Clipboard contents may be accessible to other apps; clear them after use.`);
    } catch (_) {
      setNotice('Clipboard access is unavailable. Select the value and copy it manually.');
    }
  };
  return (
    <Dialog open={Boolean(credentials)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>New account access</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Alert severity="info">These newly issued details are shown temporarily. Closing this dialog clears them from this screen. Existing passwords cannot be retrieved.</Alert>
          {credentials && [
            { label: 'Username / email', value: credentials.username },
            { label: 'Temporary password', value: credentials.password },
            { label: 'Login link', value: credentials.loginUrl },
          ].filter(item => item.value).map(item => (
            <Stack key={item.label} direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }}>
              <TextField fullWidth label={item.label} value={item.value} InputProps={{ readOnly: true }} inputProps={{ autoComplete: 'off' }}
                onFocus={event => event.target.select()} />
              <Button variant="outlined" onClick={() => copy(item.value, item.label)} aria-label={`Copy ${item.label}`} sx={{ minHeight: 44, flexShrink: 0 }}>Copy</Button>
            </Stack>
          ))}
          {notice && <Alert severity="info" role="status">{notice}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Close and clear</Button></DialogActions>
    </Dialog>
  );
}
